module.exports = __webpack_public_path__ + "static/media/expressway-logo.635df061.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/expressway-logo.svg
// module id = 644
// module chunks = 0